import Navbar from "../Components/Navbar";
import ProjectList from "../Components/ProjectList";
import Footer from "../Components/Footer";
const Projects = () => {
    return(
        <div>
            <Navbar/>
            <ProjectList/>
            <Footer/>
        </div>
    )
}
export default Projects;